// extracted by mini-css-extract-plugin
export var button = "Button-module--button--2t432";
export var black = "Button-module--black--25G20";
export var white = "Button-module--white--2Xn31";